// Modules
import React, { Component } from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
// Comps & Styling
import Landing from './comps/landing';
import Main from './comps/main';
import './App.css';

class App extends Component {
    render() {
        return (
            <Router>
                <div className="App">
                    <Route exact path="/" component={Landing}/>
                    <Route exact path="/main" component={Main}/>
                </div>
            </Router>
        );
    }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js